import React, { useState, useEffect } from "react";
import {
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  NavbarToggler,
  Collapse,
} from "reactstrap";
import "./header.css";

const Header = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 10) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <Navbar
        expand="md"
        fixed="top"
        className={`custom-navbar ${isScrolled ? "scrolled" : ""}`}
      >
        <NavbarBrand href="/">
          <img
            src="/images/indy (1).png"
            alt="Logo"
            className="logo-img"
          />
        </NavbarBrand>

        {/* Hamburger only on smaller screens */}
        <NavbarToggler className="hamburger-btn" onClick={toggleSidebar} />
        
        {/* Desktop menu */}
        <Collapse navbar className="desktop-menu">
          <Nav className="menu-group" navbar>
            <NavItem><NavLink className="pill-link" href="/#about">About Us</NavLink></NavItem>
            <NavItem><NavLink className="pill-link" href="/OurProduct">Our Product</NavLink></NavItem>
            {/* <NavItem><NavLink className="pill-link" href="#future">Future Work</NavLink></NavItem> */}
            <NavItem><NavLink className="pill-link" href="/#careers">Careers</NavLink></NavItem>
            <NavItem><NavLink className="pill-link" href="/#contact">Contact Us</NavLink></NavItem>
          </Nav>
        </Collapse>
      </Navbar>

      {/* 📌 Sidebar Drawer */}
      <div className={`sidebar ${sidebarOpen ? "open" : ""}`}>
        <button className="close-btn" onClick={toggleSidebar}>×</button>

        <Nav vertical className="sidebar-menu">
          <NavLink onClick={toggleSidebar} href="/#about">About Us</NavLink>
          <NavLink onClick={toggleSidebar} href="/OurProduct">Our Product</NavLink>
          {/* <NavLink onClick={toggleSidebar} href="#future">Future Work</NavLink> */}
          <NavLink onClick={toggleSidebar} href="/#careers">Careers</NavLink>
          <NavLink onClick={toggleSidebar} href="/#contact">Contact Us</NavLink>
        </Nav>
      </div>

      {/* Sidebar Overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar} />}
    </>
  );
};

export default Header;
